export const GET_ORGANIZATIONS = "GET_ORGANIZATIONS";
export const GET_MY_ORGANIZATIONS = "GET_MY_ORGANIZATIONS";
export const GET_ORGANIZATION_BY_ID = "GET_ORGANIZATION_BY_ID";
export const GET_TEAM_BY_ID = "GET_TEAM_BY_ID";
export const GET_TEAMS_OF_AN_ORGANIZATION = "GET_TEAMS_OF_AN_ORGANIZATION";
export const GET_USERS_OF_AN_ORGANIZATION = "GET_USERS_OF_AN_ORGANIZATION";
export const REMOVE_USER_FROM_AN_ORGANIZATION =
  "REMOVE_USER_FROM_AN_ORGANIZATION";
export const REMOVE_TEAM_FROM_AN_ORGANIZATION =
  "REMOVE_TEAM_FROM_AN_ORGANIZATION";
export const REMOVE_MEMBER_FROM_A_TEAM = "REMOVE_MEMBER_FROM_A_TEAM";
export const GET_USERS_OF_A_TEAM = "GET_USERS_OF_A_TEAM";
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const REMOVE_ORGANIZATION = "REMOVE_ORGANIZATION";
export const CREATE_TEAM = "CREATE_TEAM";
export const TOGGLE_USER_OF_ORG = "TOGGLE_USER_OF_ORG";
export const TOGGLE_USER_OF_TEAM = "TOGGLE_USER_OF_TEAM";
export const ADD_MEMBER_TO_ORG = "ADD_MEMBER_TO_ORG";
export const ADD_MEMBER_TO_TEAM = "ADD_MEMBER_TO_TEAM";
export const GET_CATEGORIES_OF_AN_ORGANIZATION =
  "GET_CATEGORIES_OF_AN_ORGANIZATION";
export const ADD_CATEGORY_TO_ORG = "ADD_CATEGORY_TO_ORG";
export const REMOVE_CATEGORY_FROM_AN_ORGANIZATION =
  "REMOVE_CATEGORY_FROM_AN_ORGANIZATION";
export const IS_LOADING = "IS_LOADING";
export const SET_CURRENT_ORGANIZATION="SET_CURRENT_ORGANIZATION";
export const SET_CURRENT_ORG_USER = "SET_CURRENT_ORG_USER";